import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import './WhyBooksComply.css';

const WhyBooksComply = () => {
  const features = [
    {
      title: "Expert Team",
      description: "Our team of certified professionals brings years of experience in accounting, tax, and business advisory services."
    },
    {
      title: "Comprehensive Solutions",
      description: "From bookkeeping to CFO advisory, we offer end-to-end financial solutions tailored to your business needs."
    },
    {
      title: "Cutting-Edge Technology",
      description: "We leverage the latest financial technologies to provide efficient and accurate services."
    },
    {
      title: "Client-Centric Approach",
      description: "Your success is our priority. We take the time to understand your unique business requirements."
    },
    {
      title: "Affordable Pricing",
      description: "High-quality financial services at competitive, transparent pricing with no hidden costs."
    },
    {
      title: "Timely Support",
      description: "Our dedicated support team is always ready to assist you with any queries or concerns."
    }
  ];

  return (
    <div className="why-bookscomply py-5">
      <Container>
        <div className="text-center mb-5">
          <h1 className="display-4 fw-bold mb-3">Why Choose BooksComply?</h1>
          <p className="lead text-muted">
            Discover how we can help streamline your financial operations and drive your business forward.
          </p>
        </div>

        <Row className="g-4">
          {features.map((feature, index) => (
            <Col key={index} md={6} lg={4}>
              <Card className="h-100 border-0 shadow-sm hover-effect">
                <Card.Body className="p-4">
                  <h3 className="h5 fw-bold mb-3">{feature.title}</h3>
                  <p className="text-muted mb-0">{feature.description}</p>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        <div className="cta-section text-center mt-5 pt-4">
          <h2 className="h3 mb-4">Ready to experience the BooksComply difference?</h2>
          <a href="/contact" className="btn btn-primary btn-lg px-4">Get Started Today</a>
        </div>
      </Container>
    </div>
  );
};

export default WhyBooksComply;
